import React, {useState} from 'react';
import {ViewSpeciesModal} from "../../../Pages/SpeciesLists/Common/Modals/ViewSpeciesModal";
import {service as SpeciesService} from "../../../../Services/SpeciesService";
import {useSelector} from "react-redux";
import {selectCurrentUser} from "../../../../Redux/Selectors/userSelectors";

export const DenySpeciesActivityFeedItemDescription = props => {
    const {Event: contextNodeActivity = null} = props;
    const {Activity: activity = null} = contextNodeActivity;
    const {data = null} = activity;
    const species = data?.newValue;
    const speciesTitle = SpeciesService.GetFullTitle(species);

    const currentUser = useSelector(selectCurrentUser);

    const [showModal, setShowModal] = useState(false);
    
    let reviewComment = null;
    let verb = 'denied';
    if(species?.SpeciesRequest) {
        if(Number(currentUser?.userId) === Number(species?.SpeciesRequest?.requestedByUserId)) {
            reviewComment = species?.SpeciesRequest?.reviewerNotes;
        }
    }

    return <p>
        <ViewSpeciesModal
            show={showModal}
            species={species}
            onHide={() => setShowModal(false)}
            warning={"The below information is a point-in-time snapshot of the species data which may be outdated. "}
        />
        {activity.User?.name} {verb} a request to add
        {' '}
        <a className="link-primary" onClick={_ => setShowModal(true)}>
            {speciesTitle}
        </a>
        {' '}
        to the Global Species list.
        {reviewComment}
    </p>;
};
